module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-6.89e7da21.jpg";